import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaGasPump } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa6";
import "./HomeHero.scss";

export default function HomeHero() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Ensure mobile autoplay compatibility
    video.muted = true;
    video.playsInline = true;
    video.play().catch(() => {});
  }, []);
  //
  return (
    <section className="home-hero">
      <video
        ref={videoRef}
        className="home-hero__video"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
      >
        <source
          src="https://sunrisebucket.s3.us-east-2.amazonaws.com/MM_HERO.mp4"
          type="video/mp4"
        />
      </video>
      <div className="home-hero__overlay" />
      <div className="home-hero__content">
        <h1>Mini Miles Adventures</h1>
        <p>
          Small car. Quiet roads. Exploring Iowa & America’s overlooked small
          towns, scenic backroads, and the stories most drive right past.
        </p>

        {/* RESPONSIVE DUAL-BUTTON WRAPPER CONTAINER */}
        <div className="home-hero__actions">
          <Link to="/watch" className="home-hero__cta">
            See Where the Road Leads
          </Link>

          {/* ⛽ NEW OUTLINE ACTION BUTTON */}
          <Link to="/shop" className="home-hero__cta home-hero__cta--secondary">
            Mini Miles Shop
          </Link>
          {/* <Link
            to="/fuel-up"
            className="home-hero__cta home-hero__cta--secondary"
          >
            <span>
              <FaGasPump />
            </span>{" "}
            Fuel the Car
          </Link> */}
        </div>
      </div>
      {/* <div
        className="home-hero__scroll-indicator"
        onClick={() =>
          window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" })
        }
      >
        <span>Scroll to Explore</span>
        <FaChevronDown className="bounce-arrow" />
      </div> */}
    </section>
  );
}
